import { SofiaAvatar } from "@/components/sofia-avatar"
import { TooltipContent, TooltipCustom, TooltipPortal, TooltipTrigger, UserTooltip } from "@/components/ui/tooltip"
import { getShortName } from "@/lib/get-short-name"
import { UserRole } from "@/types/__generated__/union-types"

type AvatarTooltipProps = {
  firstName: string | null | undefined
  lastName: string | null | undefined
  uniqueIdentifier: string
  role: UserRole
  size?: "xs" | "md"
  professionalTitle: string | undefined
}

const AvatarTooltip = (props: AvatarTooltipProps) => {
  const { firstName, lastName, uniqueIdentifier, size, role, professionalTitle } = props

  const shortName = getShortName(firstName, lastName)

  return (
    <TooltipCustom data-testid={`avatar-tooltip-${uniqueIdentifier}`}>
      <TooltipTrigger>
        <SofiaAvatar firstName={firstName} lastName={lastName} size={size} role={role} />
      </TooltipTrigger>
      <TooltipPortal>
        <TooltipContent side="bottom" align="start">
          <UserTooltip
            firstName={firstName}
            lastName={lastName}
            shortName={shortName}
            role={role}
            professionalTitle={professionalTitle}
          />
        </TooltipContent>
      </TooltipPortal>
    </TooltipCustom>
  )
}

export { AvatarTooltip }
